document.addEventListener("click", (e) => {
    const toggle = e.target.closest('.gs-accordion');
    if (!toggle) {
        return;
    }

    const panel = toggle.nextElementSibling;

    toggle.classList.toggle("gs-active");

    if (panel.style.maxHeight) {
        panel.style.maxHeight = null;
        panel.style.marginTop = null;
        panel.style.paddingBottom = null;
        panel.style.opacity = 0;
        return;
    }

    panel.style.maxHeight = `calc(${panel.scrollHeight}px + 1rem)`; // + 1rem of padding bottom
    panel.style.marginTop = "1rem";
    panel.style.paddingBottom = "1rem";
    panel.style.opacity = 1;
})